export default __webpack_public_path__ + "static/media/3393.8bb455ca.png";